module.exports = __webpack_public_path__ + "static/login-background-a0d29cea2db63b50437e4d49ae5376d0.png";